<template>
  <v-dialog v-model="openConfirmModal" width="568px">
    <v-card class="card-container" height="416px">
      <div>
        <v-toolbar
          elevation="0"
          color="background"
          class="fluid-toolbar mb-4 no-x-padding"
          height="64"
        >
          <v-toolbar-title
            class="font-weight-medium"
            style="font-size: 18px !important"
            :class="{
              'brand--text text--darken-2': !$vuetify.theme.dark,
            }"
          >
            {{ $t('message.pages.customizeModal.spotBilling') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose" class="no-ripple">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <template>
          <v-alert
            dense
            color="#A0ACFF"
            style="white-space: nowrap; font-size: 14px"
            class="d-flex align-self-center mb-0"
            compact
          >
            <v-icon class="mr-2 mb-0" size="24"> mdi-information </v-icon>
            <span class="align-self-center">
              {{ $t('message.pages.customizeModal.prePaidUpgrade') }}
            </span>
          </v-alert>
        </template>
        <v-col cols="12" class="py-5 px-0">
          <v-card width="100%" class="elevation-0 px-6" color="newBackground">
            <v-card
              
              height="78px"
              width="100%"
              color="newBackground"
              flat
            >
              <v-row
                no-gutters
                justify="center"
                align="center"
                class="fill-height"
              >
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="7">
                      <span style="font-weight: 500;" class="cartBenefitsText typeText2--text mr-1">
                        {{
                          $t('message.pages.customizeModal.actualCycle')
                        }}
                      </span>
                      <span
                        class="customizeItemsText primary--text"
                        style="font-weight: 500; cursor: pointer"
                        @click="handleMoreDetails"
                      >+ {{ $t('message.pages.customizeModal.details') }}
                      </span>
                    </v-col>
                    <v-col cols="5" class="d-flex justify-end">
                      <span style="color: var(--v-brand-darken1)" >
                        {{
                          (prorateResponse.amount_due / 100).toLocaleString(
                            currencyLocale,
                            {
                              style: 'currency',
                              currency: currency,
                            }
                          )
                        }}
                      </span>
                    </v-col>
                    <v-col cols="7">
                      <span  class="customizeItemsText">
                        {{ $t('message.pages.customizeModal.expiry') }}
                        {{ formatData(prorateResponse.period_end) }}
                      </span>
                    </v-col>
                    <v-col cols="5" class="d-flex justify-end">
                      <span class="customizeItemsText">
                        {{
                          $t('message.pages.customizeModal.proporcionalValue')
                        }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </v-col>
        <v-col cols="12" class="px-0 py-0">
          <v-card width="100%" class="elevation-0 px-6" color="newBackground">
            <v-card height="72px" width="100%" color="newBackground" flat>
              <v-row
                no-gutters
                justify="center"
                align="center"
                class="fill-height"
              >
                <v-col>
                  <span>
                    <v-row no-gutters>
                      <v-col cols="12" class="align-center">
                        <v-row no-gutters>
                          <v-col
                            cols="5"
                            class="d-flex"
                            style="align-self: center"
                          >
                            <span
                              class="mr-2 d-flex"
                              :class="{
                                paymentMethodText: !$vuetify.theme.dark,
                              }"
                            >
                              {{
                                $t('message.pages.customizeModal.paymentMethod')
                              }}
                            </span>
                          </v-col>
                          <v-col
                            class="ml-auto d-flex"
                            style="align-self: center"
                          >
                            <v-progress-circular
                              v-if="editingCardLoading"
                              class="ml-9"
                              :size="19"
                              width="2"
                              color="gray"
                              indeterminate
                            />
                          </v-col>
                          <template v-if="defaultSource && defaultSource.type">
                            <v-col
                              cols="5"
                              class="ml-auto"
                              style="align-self: center"
                            >
                              <v-container
                                style="padding: 0"
                                class="d-flex justify-end container__wrapper"
                              >
                                <v-select
                                  :items="paymentSources"
                                  v-model="selectedItem"
                                  :menu-props="{ top: false, offsetY: true }"
                                  dense
                                  hide-details
                                  solo
                                  flat
                                  return-object
                                >
                                  <template #selection="{ item }">
                                    <template v-if="item.type === 'boleto'">
                                      <v-card
                                        style="padding-left: 2px"
                                        outlined
                                        width="35"
                                        height="24"
                                        class="rounded card-image d-flex align-center justify-center"
                                      >
                                        <v-img
                                          src="@/assets/boletoIcon.svg"
                                          max-width="24"
                                        />
                                      </v-card>
                                      <span class="pl-2">
                                        {{
                                          $t('message.pages.userPlan.ticket')
                                        }}
                                      </span>
                                    </template>
                                    <template v-else>
                                      <v-card
                                        style="padding-left: 2px"
                                        outlined
                                        width="35"
                                        height="24"
                                        class="rounded card-image d-flex align-center justify-center"
                                      >
                                        <v-img
                                          :src="
                                            cardsImages[
                                              `${item.brand.toLowerCase()}`
                                            ]
                                          "
                                          max-width="35"
                                          class="rounded card-image"
                                        />
                                      </v-card>
                                      <span class="pl-2">
                                        {{
                                          capitalizeFirstLetter(item.brand)
                                        }}-{{ item.last4.trim() }}</span
                                      >
                                    </template>
                                  </template>
                                  <template #item="{ item }">
                                    <template v-if="item.type === 'boleto'">
                                      <v-card
                                        style="padding-left: 2px"
                                        outlined
                                        width="35"
                                        height="24"
                                        class="rounded card-image d-flex align-center justify-center"
                                      >
                                        <v-img
                                          src="@/assets/boletoIcon.svg"
                                          max-width="24"
                                        />
                                      </v-card>
                                      <span
                                        class="pl-2"
                                        :class="{
                                          font__color: !$vuetify.theme.dark,
                                        }"
                                      >
                                        {{
                                          $t('message.pages.userPlan.ticket')
                                        }}
                                      </span>
                                    </template>
                                    <template v-else>
                                      <v-card
                                        outlined
                                        width="35"
                                        height="24"
                                        class="rounded card-image d-flex align-center justify-center"
                                      >
                                        <v-img
                                          :src="
                                            cardsImages[
                                              `${item.brand.toLowerCase()}`
                                            ]
                                          "
                                          max-width="35"
                                          class="rounded card-image"
                                        />
                                      </v-card>
                                      <span
                                        class="pl-2"
                                        :class="{
                                          font__color: !$vuetify.theme.dark,
                                          'font__color-select':
                                            $vuetify.theme.dark,
                                        }"
                                      >
                                        {{
                                          capitalizeFirstLetter(item.brand)
                                        }}-{{ item.last4 }}
                                      </span>
                                    </template>
                                  </template>
                                </v-select>
                              </v-container>
                            </v-col>
                          </template>
                          <template v-else>
                            <span>
                              {{ $t('message.pages.userPlan.noPaymentMethod') }}
                            </span>
                          </template>
                        </v-row>
                      </v-col>
                    </v-row>
                  </span>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </v-col>
        <v-col class="mt-10 px-0" cols="12">
          <v-btn
            class="primary float-right"
            @click="handleCheckout"
            :disabled="hasError && defaultSource"
            :loading="isFetchingCheckout"
          >
            {{ $t('message.pages.customizeModal.toPay') }}
          </v-btn>
        </v-col>
      </div>
      <v-col
        v-if="errors.deleteUnknownError"
        cols="6"
        class="px-0"
        style="padding: 0"
      >
        <v-card flat height="30">
          <span
            class="red--text footerText align-text d-block my-1"
            style="font-size: 13px"
          >
            {{ errors.deleteShownErrMsg }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon size="18" v-bind="attrs" v-on="on">
                  mdi-help-circle
                </v-icon>
              </template>
              <v-container class="text-body-2 pa-0" style="max-width: 230px">
                {{ errors.deleteErrMsg }}
              </v-container>
            </v-tooltip>
          </span>
        </v-card>
      </v-col>
    </v-card>
    <CustomizePlanDetails/>

  </v-dialog>
</template>

<script>
import planApi from '@/services/planApi'
import i18n from '@/translations/lang'
import CustomizePlanDetails from '@/components/CustomizePlanDetails.vue'

export default {
  name: 'CustomizePlanConfirmModal',
  components: {
    CustomizePlanDetails,
  },
  data: () => ({
    currencyLocale: 'pt-BR',
    currency: 'brl',
    paymentMethod: [],
    selectedItem: {},
    editingCardLoading: false,
    errors: {
      fetchData: false,
      deleteUnknownError: false,
      deleteShownErrMsg: '',
      deleteErrMsg: '',
    },
    hasError: false,
  }),
  props: {
    prohataObjects: {
      type: Array,
    },
    prorateResponse: {
      type: Object,
    },
    getPayDate: {
      type: String,
    },
    userCurrency: {
      type: String,
    },
    paymentSources: {
      type: Array,
    },
    defaultSource: {
      type: Object,
    },
    cardsImages: {
      type: Object,
    },
    openConfirmModal: {
      type: Boolean,
    },
    isFetchingCheckout: {
      type: Boolean,
    },
  },

  watch: {
    selectedItem(paymentMethod) {
      if (paymentMethod.id !== this.defaultSource.id) {
        this.changeDefaultPayment(paymentMethod)
      }
    },
    openConfirmModal(val) {
      this.selectedItem = this.defaultSource
      if (!val) this.handleClose()
    },
  },
  mounted() {
    this.setCurrencyConfig()
  },
  methods: {
    handleClose() {
      this.openConfirmModal = false
      this.clearErrors()
      this.$root.$emit('CloseConfirmModal', this.openConfirmModal)
    },
    setCurrencyConfig() {
      const currency = this.userCurrency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    handleMoreDetails() {
      this.$root.$emit(
        'openCustomizePlanDetails',
        this.prohataObjects,
        this.prorateResponse
      )
    },
    capitalizeFirstLetter(string) {
      if (!string) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    handleCheckout() {
      this.$root.$emit('handleCheckout')
    },
    async changeDefaultPayment(payment) {
      this.clearErrors()
      this.editingCardLoading = true
      this.hasError = true
      try {
        await planApi.changeDefaultCard(payment.id)
        this.editingCardLoading = false
        this.hasError = false
      } catch (e) {
        this.handleFetchError(e)
        this.editingCardLoading = false
        this.hasError = true
      }
    },
    formatData(timestamp) {
      const data = new Date(timestamp * 1000)

      const dia = data.getDate().toString().padStart(2, '0')
      const mes = (data.getMonth() + 1).toString().padStart(2, '0')
      const ano = data.getFullYear().toString().slice(-2)

      return `${dia}/${mes}/${ano}`
    },
    handleFetchError(err) {
      this.errors.deleteShownErrMsg = i18n.t('message.errors.unexpectedError')
      let errString = ''
      if (
        err?.response?.data &&
        err?.response?.data?.errMsg &&
        err?.response?.data?.errCode
      ) {
        errString = err.response.data.errCode + err.response.data.errMsg
      }
      this.errors.deleteUnknownError = true
      this.errors.deleteErrMsg =
        err.msg ?? errString ?? err.response.data.message ?? 'Error'
      if (err?.response?.data?.detail?.raw?.message) {
        this.errors.deleteErrMsg = err.response.data.detail.raw.message
      }
    },
    clearErrors() {
      Object.keys(this.errors).forEach((key) => {
        if (typeof this.errors[key] === 'boolean') {
          this.$set(this.errors, key, false)
        } else {
          this.$set(this.errors, key, '')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.mdi-information {
  color: #0f21a1 !important;
}

.not-allowed {
  cursor: not-allowed !important;
}
.no-x-padding {
  .v-toolbar__content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.fluid-toolbar {
  &.small {
    height: unset !important;

    .v-toolbar__content {
      height: unset !important;
      padding: 16px 24px 24px 24px;
    }
  }
  &:not(.small) {
    .v-toolbar__content {
      padding: 24px 32px 0px 32px;
    }
  }
}

.font__color {
  color: black !important;
}
.font__color-select {
  color: #ffffff !important;
  opacity: 0.99;
}

.v-application .small-title.text-h6 {
  font-size: 18px !important;
}
::v-deep .v-list-item--link.theme--dark::before {
  background-color: #171924;
}

::v-deep .theme--dark.v-list-item:hover::before {
  opacity: 0.2;
  background-color: #c2c6c4 !important;
}

::v-deep .theme--light.v-list-item:hover::before {
  opacity: 0.2;
  background-color: #585d83 !important;
}

::v-deep .v-list-item--link.theme--light::before {
  background-color: rgb(255, 255, 255);
}

.card-container {
  max-height: 90vh;
  > div {
    max-height: inherit;
  }
  ::v-deep * {
    font-family: Rubik !important;
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .v-toolbar__content,
  .v-toolbar__items,
  .v-toolbar__items > button {
    height: unset !important;
    width: auto !important;
  }

  &:not(.no-padding) {
    padding: 0px 32px 0px 32px !important;
  }
}

.align-center {
  align-items: center !important;
}
small {
  line-height: 20px;
}

.cartBenefitsText {
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
}

.customizeItemsText {
  font-weight: 400;
  font-size: 14px;
}

.paymentMethodText {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #585d83;
}
</style>
